import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../components/shared/fields/InputWithLabel";
import Button from "../../components/shared/buttons/button";
import useTranslator from "../../hooks/useTranslator";
import { useCreatePackingPendingMutation, useGetPackingPendingQuery } from "./mixingApi";

const PackingPendingModal = ({ show, setShow, batchCode }) => {
  const { _t } = useTranslator();

  const [formData, setFormData] = useState({
    material_unit: "",
    description:   "",
  });

  const [createPackingPending, { isLoading: isCreating }] = useCreatePackingPendingMutation();

  // Fetch existing record to prefill
  const { data: pendingLog } = useGetPackingPendingQuery(
    { batch_code: batchCode },
    { skip: !show || !batchCode }
  );

  // Prefill from existing record when modal opens or data changes
  useEffect(() => {
    if (show) {
      const record = pendingLog?.data?.find(
        (r) => r.material_key === "packing_material" && r.belongs_to === "packing"
      ) ?? null;
      setFormData({
        material_unit: record?.material_unit ?? "",
        description:   record?.material_description ?? "",
      });
    }
  }, [show, pendingLog]);

  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating) return;
    try {
      await createPackingPending({
        batch_code:    batchCode ? String(batchCode) : "",
        material_unit: parseFloat(formData.material_unit) || 0,
        description:   formData.description || "",
      }).unwrap();
      handleClose();
    } catch (err) {
      console.error("Error saving packing pending:", err);
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("add_packing_pending", "Add Packing Pending")}
    >
      <Row>
        <Col lg={12}>
          <InputWithLabel
            label={_t("weight_in_kg", "Weight In KG")}
            type="number"
            name="material_unit"
            value={formData.material_unit}
            onChange={handleChange}
            placeholder="0"
          />
        </Col>
        <Col lg={12}>
          <InputWithLabel
            label={`${_t("description", "Description")} (${_t("optional", "Optional")})`}
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder={_t("description", "Description")}
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default PackingPendingModal;
